import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'chartsCoreDomainRatings',
    label: 'Core Domain Ratings',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
